import styles from './index.css';
import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import { getQuanDataList } from '../quan/getQuanData';
// import { SubTitle } from '../index';
import { InformationFlow } from '@ifeng-fe/three_terminal/es/mobile/informationFlow/index.js';
import { getQuanData } from './getQuanData';
import TopicTitle from '../../../components/topicTitle';
// 网友热议中的圈子列表
// eslint-disable-next-line react/prop-types
export const Quan = ({ content }) => {
    // 帖子列表
    const [articleList, setArticleList] = useState([]);
    const [showAll, setShowAll] = useState(false);
    const [num, setNum] = useState(0);
    // 获取圈子数据
    // 发送评论请求
    // 发送点赞请求
    const getData = async ids => {
        // 从content 中的ID 里获取

        // eslint-disable-next-line react/prop-types
        const { data } = content;

        // eslint-disable-next-line react/prop-types
        const { number } = data;

        setNum(number);
        // eslint-disable-next-line react/prop-types
        const quanData = await getQuanData(data[0]['circle']['key'], data[0]['label']['label'], getQuanDataList);

        console.log(data, '');
        setArticleList(quanData);
    };

    useEffect(() => {
        getData();
    }, []);
    const showOthers = () => {
        setShowAll(true);
    };
    // eslint-disable-next-line react/prop-types
    const UnfoldMore = function UnfoldMore({ text, onClick, mask }) {
        return (
            <div onClick={onClick} className={styles.unfoldMore}>
                {mask ? <div className={styles.unfoldMore_mask} /> : null}
                <span>{text || '展开全部'}</span>
                <img src={require('./more.png')} alt="" />
            </div>
        );
    };

    return (
        <div>
            {articleList.length > 0 && (
                <div>
                    {/* eslint-disable-next-line react/prop-types */}
                    <TopicTitle title={content.title} moduleIndex={content.moduleIndex} id={content.id} />
                    <div className={styles.category} style={{ backgroundColor: 'white' }}>
                        <InformationFlow
                            getVideoPlayNum={false}
                            isDisplayLoadingMore={false}
                            isFormatTime={true}
                            isNoPadding={true}
                            content={showAll ? articleList : articleList.slice(0, num)}
                            // isDisplayLoadingMore={false}
                            // isNewsTime={!!item.newsTimeDisplay}
                            // isFormatTime={true}
                        />
                        {articleList.length > num && <UnfoldMore onClick={showOthers} text={'查看更多'} />}
                    </div>
                </div>
            )}
        </div>
    );
};
